<template>
  <div class="draw-content">
    <div class="qr-code">
      <qrcode-vue :value="qrcodeSrc" :size="250" level="M"></qrcode-vue>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { previewSheetApi } from "@/api/score";
export default {
  props: ["musicId"],
  components: {
    QrcodeVue,
  },
  data() {
    return {
      qrcodeSrc: "",
    };
  },
  watch: {
    musicId() {
      this.handleGetCode();
    },
  },
  created() {
    if (!this.musicId) {
      return false;
    }
    this.handleGetCode();
  },
  methods: {
    handleGetCode() {
      previewSheetApi({
        music_id: this.musicId,
      }).then((res) => {
        this.qrcodeSrc = res.data.url;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.draw-content {
  #qrcode {
    padding: 5px;
  }
}
</style>
